<template>
    <div id="classask"
         class="error-task">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">第{{qnumber}}题</p>
        </div>
        <div v-if="loading">
            <div class="nodata"
                 v-if="questions && !questions.length">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <div class="wrap"
                 v-else>
                <div class="question"
                     v-for="data in questions">
                    <p class="title"
                       v-if="number&&Object.keys(data.subject).length">
                        <!-- <span class="order">{{number}}</span> -->
                        <span v-if="data.subject.content"
                              v-html="data.subject.content"></span>
                        <img :src="data.subject.image.url||data.subject.image"
                             v-if="data.subject.image || data.subject.image.url" />
                    </p>
                    <!-- <div class="img-wrap">
          </div> -->
                    <!-- 小学 -->
                    <div v-if='sid == 21'>
                        <div v-for="ask,inx in data.asks">
                            <!-- 选择题 -->
                            <div class="choose"
                                 v-if="ask.display_type==1">
                                <choice :question='ask'
                                        :askLength='data.asks.length'
                                        :mystatus="1"></choice>
                            </div>
                            <!-- 填空 -->
                            <div v-if='ask.display_type == 2'>
                                <blanks :question='ask'
                                        :askLength='data.asks.length'></blanks>
                            </div>
                            <!-- 主观题 -->
                            <div v-if='ask.display_type == 3'>
                                <subjective :ask='data.asks'
                                            :index='inx'
                                            :question='ask'
                                            :askLength='data.asks.length'></subjective>
                            </div>
                            <!-- 连线题 -->
                            <div class="line"
                                 v-if="ask.display_type==4">
                                <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                                <lines :ask='ask'
                                       :sheet="ask.right_answer"
                                       :onlyshow='false'
                                       :askLength='data.asks.length'></lines>
                            </div>
                        </div>
                    </div>
                    <!-- 初中 -->
                    <div v-else>
                        <div v-for="ask,inx in data.asks">
                            <!-- 选择题 -->
                            <div class="choose"
                                 v-if="data.display==1">
                                <choice :question='ask'
                                        :askLength='data.asks.length'></choice>
                            </div>
                            <!-- 填空 -->
                            <div v-if='data.display == 2'>
                                <blanks :question='ask'
                                        :askLength='data.asks.length'></blanks>
                            </div>
                            <!-- 主观题 -->
                            <div v-if='data.display == 3'>
                                <subjective :ask='data.asks'
                                            :index='inx'
                                            :question='ask'
                                            :askLength='data.asks.length'></subjective>
                            </div>
                            <!-- 连线题 -->
                            <div class="line"
                                 v-if="data.display == 4">
                                <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                                <lines :ask='ask'
                                       :sheet="ask.right_answer"
                                       :onlyshow='false'
                                       :askLength='data.asks.length'></lines>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="wrong_names">
                <div class="content"
                     v-if="wrong_names.length">
                    <div class="title">答错<span>{{wrong_names.length}}</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names">{{name}}</span>
                    </div>
                </div>
                <div class="content"
                     v-else>
                    <div class="title">答错<span>0</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names"></span>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/tealoading.vue';
import choice from 'VIEWS/math/module/choice.vue'  //选择题
import blanks from 'VIEWS/math/module/blanks.vue'  //填空题
import lines from 'VIEWS/math/module/line.vue';     //连线题
import subjective from 'VIEWS/math/module/subjective.vue';//主观题
export default {
    data () {
        return {
            sid: this.$route.params.sid,
            classid: this.$route.params.classid,
            taskid: this.$route.params.taskid,
            qid: this.$route.query.qid,
            askid: this.$route.query.askid,
            qnumber: null,
            number: this.numbertit(),
            testType: this.$route.query.testType,
            wrong_names: [],
            questions: [],
            loading: false
        }
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
        numbertit () {
            let str = this.$route.params.qnumber;
            if (str.indexOf("(") > 0) {
                return str.substring(str.indexOf("("))
            } else {
                return false
            }
        },
    },
    created () {
        //this.questions=null;
        let _qnumber = this.$route.params.qnumber;
        this.qnumber = _qnumber.replace(/\(.*?\)/g, '');//删除括号及括号内内容
        this.$http.post(API_URL_TASK_API + "/maths/check/task/ask", {
            "sid": this.sid,
            "message_id": this.taskid,
            "unit_class_id": this.classid,
            "ask_id": this.askid,
            "question_id": this.qid
        }).then(res => {
            res = res.data;
            this.loading = true;
            if (res.response == "ok") {
                this.wrong_names = res.data.wrong_stu
                this.questions = res.data.question;
                //this.qnumber=this.questions[0].asks[0].number;
                this.$nextTick(function () {
                    MathJax.Hub.Typeset(document.body);
                })
            }
        });
    },
    destroyed () {
    },
    components: {
        loadingS,
        subjective,
        choice,
        blanks,
        lines
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.error-task {
    min-height: 100vh;
    padding-top: 96px/$ppr;
   .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 96px / $ppr;
        background: #5e89ef;

        .back {
            position: absolute;
            top: 0;
            left: 0;
            width: 76px / $ppr;
            height: 96px / $ppr;
            background: url(./img/choose_back.png) no-repeat center;
            background-size: 18px / $ppr 34px / $ppr;
        }

        .title {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 34px / $ppr;
            color: #fff;
            text-align: center;
        }

    }
}

.content {
    background-color: $c-fbg;
    .title {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 36px / $ppr;
        padding: 0 $w;
        border-bottom: 1px / $ppr solid $line;
        font-weight: 600;
    }
    .name {
        padding: $w $w;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        min-height: 200px / $ppr;
        span {
            width: 25%;
            font-size: 30px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
        }
    }
}

.nodata {
    color: $c-light;
    margin-top: 50px / $ppr;
    margin-bottom: 50px / $ppr;
    text-align: center;
    span {
        display: inline-block;
        color: $c-litgray;
        font-size: 110px / $ppr;
        margin-bottom: 36px / $ppr;
    }
}

.question {
    margin-bottom: 24px / $ppr;
    .order {
        color: $c-theme;
    }
    .title {
        background-color: $c-fbg;
        border-bottom: 1px / $ppr solid $line;
        padding: $w $w;
        span {
            display: inline-block;
        }
        img {
            display: inline-block;
        }
    }
    .img-wrap {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: center;
        -webkit-justify-content: center;
        background: #fff;
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: $w;
        background-color: $c-fbg;
    }
    .subtitle-wrap {
        border-bottom: 1px / $ppr solid $line;
    }
    .subtitle {
        padding: $w $w;
    }
    /* .option{
      padding: $w $w;
      border-bottom:1px/$ppr solid $line;
      display: flex;
      flex-wrap:wrap;
      .spot{
        display: block;
        width:$w*2;
        height:$w*2;
        line-height:$w*2;
        text-align: center;
        border:1px/$ppr solid $c-gray;
        border-radius:$w;
        margin-right:$w;
      }
	} */
    .checked {
        color: #66cc22 !important;
        .spot {
            background-color: #66cc22 !important;
            border: 1px / $ppr solid #66cc22 !important;
            color: #fff;
        }
    }
}

.question .option:last-child {
    border: 0 !important;
}

.question /deep/ .choose ul li:last-child {
    border: 0 !important;
}
</style>
